import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

document.addEventListener('DOMContentLoaded', function (e) {
  const projectsAnimatedBlock = e.target.querySelector(
    '.animated-projects__block'
  )
  if (projectsAnimatedBlock) {
    gsap.registerPlugin(ScrollTrigger)

    const items = gsap.utils.toArray('.feed-animated-project')

    if (items.length > 0) {
      let stickDistance = 0
      let lastCardST = ScrollTrigger.create({
        trigger: items[items.length - 1],
        start: 'top top',
      })

      items.forEach((card) => {
        ScrollTrigger.create({
          trigger: card,
          start: 'top top',
          end: () => lastCardST.start + stickDistance,
          pin: true,
          pinSpacing: false,
        })
      })
    }
  }
})
